import * as React from "react";
import { Trans } from "react-i18next";
import { IShipment } from "~/graphql/queries/shipment/shipmentsByIds";
import getOrderNumber, { Order } from "~/helpers/getOrderNumber";

interface IProps {
  order: Order;
  shipment?: IShipment;
}

export default class ArriveDestinationCountry extends React.Component<IProps> {
  public render() {
    const { order } = this.props;

    return (
      <Trans i18nKey="trackTrace:statusExplanation.arriveDestinationCountry">
        Je bestelling met ordernummer{" "}
        <strong>{{ orderNumber: getOrderNumber(order) }}</strong> is aangekomen
        op het vliegveld in China, en wordt klaargemaakt voor vertrek. De vlucht
        kan soms even duren, maar na het landen gaat het heel snel!
      </Trans>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrackTrace/Statuses/ArriveDestinationCountry.tsx